import styled from 'styled-components';
import { config } from '@keytrade/functions';
import { Card as CardSC } from '@keytrade/components-card';

import { mediaQuery, mediaQueryMax } from '@/utils/helpers';

const { list: colors } = config.colors;

export const Wrapper = styled.div`
  scroll-margin: 10rem;
`;

export const CardWrapper = styled(CardSC)`
  padding: 0;
  border-radius: 1.2rem;
  width: 100%;
  overflow: hidden;
  box-shadow: none;
  @media screen and (min-width: 768px) {
    box-shadow: ${(props) =>
      props.isDark
        ? '0px 2px 5px 0px rgba(0,0,0,0.1), 0px 2px 7px 0px rgba(0,0,0,0.1)'
        : '0px 2px 5px 0px rgba(0,0,0,0.05), 0px 2px 7px 0px rgba(0,0,0,0.05)'} !important;
    border-width: 1px;
    border-style: solid;
    border: ${(props) =>
      props.isDark ? 'none' : `1px solid ${colors.GreyWhite}`} !important;
    background-color: ${(props) =>
      props.isDark ? 'transparent' : `${colors.GreyWhite}`} !important;
  }
`;

export const List = styled.ul<{ isDark: boolean }>`
  list-style: none;
  padding: 0;
  margin: 0;
  ${(props) =>
    !props.isDark &&
    `
      ${mediaQueryMax.md(`
        border: 1px solid ${colors.GreyLight};
        border-radius: 1.2rem;
        overflow:hidden;
  `)}
  `}
`;

export const ListElement = styled.li<{ isDark: boolean }>`
  & + & {
    border-top-width: 1px;
    border-top-style: solid;
  }
  border-top-color: ${(props) =>
    props.isDark ? colors.BlueDark : colors.GreyWhite} !important;
  ${mediaQueryMax.md(`
    border-top-color: ${(props) =>
      props.isDark ? colors.BlueDark : colors.GreyLight} !important;
  `)}
`;

// Video overlay
// TODO: Share styles with the SmallCard component
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
`;

export const BackgroundLayer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(60, 84, 99, 0.75);
  pointer-events: all;
  transition: opacity 0.2s cubic-bezier(0.23, 1, 0.32, 1);
`;

export const VideoModal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 1080px;
  width: 100%;
  height: 300px;
  padding: 0 20px;
  ${mediaQuery.md(`
    height: 450px;
  `)}
  ${mediaQuery.xl(`
    height: 608px;
    padding: 0;
  `)}
`;

export const CloseWrapper = styled.a`
  display: inline-flex;
  justify-content: center;
  position: absolute;
  right: 20px;
  top: -40px;
  width: 32px;
  height: 32px;
  align-items: center;
  background-color: ${colors.BlueDark};
  border-radius: 50%;
`;
